import React, { FC } from 'react';

import { Popup } from '@silverfort/sf-components';

import ActivityPopupContent from './ActivityPopupContent/ActivityPopupContent';
import ActivityFooter from './ActivityFooter';
import { ActivityEntity } from '../../api/types/Insights';

interface Props {
    open: boolean;
    onClose: () => void;
    title: string;
    activityPrefix: string;
    counterColumnTitle: string;
    activityUsers: ActivityEntity[];
    activityResources: ActivityEntity[];
}

const ActivityPopup: FC<Props> = ({
    open,
    onClose,
    title,
    activityPrefix,
    counterColumnTitle,
    activityUsers,
    activityResources
}) => {
    return (
        <Popup
            open={open}
            title={title}
            ContentComponent={ActivityPopupContent}
            ContentComponentProps={{
                activityUsers,
                activityResources,
                activityPrefix,
                counterColumnTitle
            }}
            FooterComponent={ActivityFooter}
            FooterComponentProps={{}}
            onApprove={onClose}
            onClose={onClose}
            popupClassName="w-[824px] h-[70vh] max-w-full font-sf"
        />
    );
};

export default ActivityPopup;
